// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XIiq","left":"styles_left__3C7h6","desktopActions":"styles_desktopActions__6E3QH","title":"styles_title__CZTsy"};